import constants from './constants';
import * as moment from "moment";

export function columnFilter(data, string) {
  if(data.value === null)
  {
    return false;
  }
  if(typeof(data.value) == 'number')
  {
    return data.value.toString().indexOf(string) !== -1;
  }
  return data.value.toLowerCase().indexOf(string.toLowerCase()) !== -1;
}

export function dateSort_ddmmyy(a,b){
  var momentA = moment(a.value, constants.DD_MM_YY);
  var momentB = moment(b.value, constants.DD_MM_YY);
  if (momentA > momentB) return 1;
    else if (momentA < momentB) return -1;
    else return 0;
 }
 export function dateSort_ddmmyyyy(a,b){
  var momentA = moment(a.value, constants.DD_MM_YYYY);
  var momentB = moment(b.value, constants.DD_MM_YYYY);
  if (momentA > momentB) return 1;
    else if (momentA < momentB) return -1;
    else return 0;
 }

export function amountSort(x,y){
  x = parseFloat(x.value.replace(/\$|,/g, ''));
  y = parseFloat(y.value.replace(/\$|,/g, ''));
  return x>y ? -1 : x<y ? 1 : 0;
}

export function columnSort(x, y) {

  return (x.value < y.value ? -1 : (x.value > y.value ? 1 : 0));
}

export const stateList = ['NSW', 'VIC', 'QLD', 'TAS', 'SA', 'WA', 'NT', 'ACT'];

export function buildBreadCrumb(params){
  let result = [];
  for (let key in params) {
    let obj = {
      name : key,
      link : params[key]
    };
    result.push(obj);
  }
  return result;
}

export function buildDefinitionList(params){
  let result = [];
  for (let key in params) {
    let obj = {
      'title' : key,
      'desc' : params[key]
    };
    result.push(obj);
  }
  return result;
}

export function getRoleName(role) {
  const matchingRole = constants.USER_ROLES.find(r => r.name === role);
  return matchingRole ? matchingRole.fullName : role;
}

export const zeroPad = (num, places) => String(num).padStart(places, '0');
